import Layout from "../../../components/Layout";
import useStyles from "../styles";
import BreadCrumb from "../../../components/BreadCrumb";
import { Grid } from "@mui/material";
import Badge from "../../../components/Badge";
import Button from "../../../components/Button";
import { httprequest } from "../../../data/api";
import { useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import PageLoader from "../../../components/PageLoader";
import nocomment from "../../../assets/images/empty_chat.svg";
import { Icon } from "@iconify/react/dist/iconify.js";
// import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import { useUserState } from "../../../context/UserContext";
import ReactQuill from "react-quill";
import parse from "html-react-parser";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";

const GET_TICKET_BY_ID = "/api/v1/ticket/";
const CLOSE_TICKET_BY_ID = "/api/v1/tickets/";
const REPLY_ADMIN = "api/v1/tickets/reply/user";
const POST_COMMENT = "/api/v1/tickets/comments/user";
const COMMENTS_ENDPOINT = "/api/v1/tickets/comments";
const UPLOAD_ENDPOINT = "/api/v1/upload";

const ViewTicket = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const { profile } = useUserState();
  const classes = useStyles();
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [ticketDetails, setTicketDetails] = useState([]);
  const [replyComment, setReplyComment] = useState("");
  const [commentModal, setCommentModal] = useState(false);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [replyToCommentId, setReplyToCommentId] = useState(null);
  const [selectedFile, setSelectedFile] = useState([]);
  const [viewImages, setViewImages] = useState(false);
  const [ticketRating, setTicketRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [displayChatbot, setDisplayChatBot] = useState(false);
  const [rateticket, setRateTicket] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const [closeticketForm, setCloseticketForm] = useState({
    comment: ""
  });

  const handleToggleMessage = () => {
    setDisplayChatBot(true);
  };

  const handleRateTicket = () => {
    setRateTicket(!rateticket);
  };

  /**
   * Set View images to false
   * set no images
   */
  const handleViewImages = () => {
    setViewImages(false);
    setSelectedImageUrl(null);
  };

  const commentsEndRef = useRef(null);
  /**
 * Scrolls to the bottom of the comments section.
 * @function
 * @description Uses a ref to the comments end element to smoothly scroll to the bottom.
 */
  const scrollToBottom = () => {
    if (commentsEndRef.current) {
      commentsEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  /**
   * handle change for closing ticket details.
   * @param {*} e - The event object from the input change.
   */
  const handleCloseTicketChange = (e) => {
    const { name, value } = e.target;
    setCloseticketForm({
      ...closeticketForm,
      [name]: value
    });
  };

  const handleCommentModal = () => {
    setCommentModal(!commentModal);
  };

  const handleCloseRateModal = () => {
    setCommentModal(false);
    setTicketRating(0);
    setCloseticketForm({
      comment: ""
    });
  };

  /**
 * Formats a date string into a readable time and date format.
 * @function
 * @param {string} dateString - The date string to format.
 * @returns {string} Formatted time string in "HH:MM MM/DD" format.
 */
  const formatTime = (dateString) => {
    const dateObject = new Date(dateString);

    const day = dateObject.getUTCDate().toString().padStart(2, "0");
    const month = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
    const hours = dateObject.getUTCHours().toString().padStart(2, "0");
    const minutes = dateObject.getUTCMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}  ${month}/${day}`;
  };

  /**
 * Cancels the current reply operation.
 * @description Resets the reply state variables.
 */
  const handleCancelReply = () => {
    setReplyToCommentId(null);
    setReplyComment("");
  };

  /**
 * Fetches comments and replies for the current ticket.
 * @description Retrieves comments from the server, combines them with replies,
 * sorts chronologically, and updates the comments state.
 */
  const fetchComments = () => {
    httprequest
      .get(`${COMMENTS_ENDPOINT}/${id}`)
      .then((res) => {
        const fetchedComments = res?.data?.data || [];

        // Combine comments and replies into a single array
        const combinedCommentsAndReplies = fetchedComments.flatMap(comment => {
          const commentEntry = { ...comment, type: "comment" };
          const replyEntries = comment.replies.map(reply => ({ ...reply, type: "reply", parentCommentId: comment?.id, ref_type: comment?.ref_type }));

          return [commentEntry, ...replyEntries];
        });

        // Sort by the created_at field (chronologically)
        combinedCommentsAndReplies.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        setComments(combinedCommentsAndReplies);
        scrollToBottom();
      })
      .catch(() => {
        toast.error("Failed to fetch comments");
      });
  };

  /**
 * Adds a new comment to the ticket.
 * @description Validates and posts a new comment to the server, then refreshes the comments list.
 */
  const handleAddComment = async () => {
    setSendingMessage(true);
    try {
      let uploadedImages = {};
      if (selectedFile?.length > 0) {
        const formData = new FormData();
        selectedFile.forEach((file) => {
          formData.append("file", file);
        });

        const response = await httprequest.post(`${UPLOAD_ENDPOINT}`, formData);

        if (response?.status === 200 && response?.data?.data) {
          uploadedImages = response?.data?.data.map((file) => ({
            upload_id: file?.upload_id,
            file_url: file?.file_url
          }));
        }

        // Append the new comment to the existing comments
        const updatedComments = newComment;
        if (updatedComments === "") {
          toast.error("Enter Comment.");

          return;
        }

        const payload = { comment: updatedComments, support_ticket_id: id, attachment: uploadedImages };

        await httprequest.post(POST_COMMENT, payload);
        toast.success("Comment added successfully");
        setNewComment("");
        fetchComments();
        setSelectedFile(null);
        setSendingMessage(false);
        setComments();
      } else {
        // Append the new comment to the existing comments
        const updatedComments = newComment;
        if (updatedComments === "") {
          toast.error("Enter Comment.");

          return;
        }

        const payload = { comment: updatedComments, support_ticket_id: id };

        await httprequest.post(POST_COMMENT, payload);
        toast.success("Comment added successfully");
        setNewComment("");
        fetchComments();
        setComments();
      }
    } catch (err) {
      setSendingMessage(false);
      toast.error(err?.response?.data?.message);
    }
  };

  /**
 * Defines allowed formatting options for the Quill editor.
 * Disallows embedding images or videos.
 *
 * @type {string[]}
 */
  const Quillformats = ["background", "bold", "color", "font", "code", "italic", "link", "size",
    "strike", "script", "underline", "blockquote", "header", "indent", "list", "align", "direction", "code-block", "formula"
    // 'image'
    // 'video'
  ];

  /**
 * Prevents file drop (e.g., images) into the Quill editor.
 *
 * @param {DragEvent} event - The drag event.
 */
  const handleEditorDrop = (event) => {
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      // Prevent drop if it's a file (e.g., image)
      event.preventDefault();
      event.stopPropagation();
    }
  };

  /**
 * Prevents image pasting into the Quill editor.
 *
 * @param {ClipboardEvent} event - The paste event.
 */
  const handlePaste = (event) => {
    const items = event.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      // Check if any pasted item is an image
      if (items[i].type.indexOf("image") !== -1) {
        event.preventDefault(); // Prevent the paste

        return;
      }
    }
  };

  /**
 * Handles changes from the Quill editor (rich text input).
 * Updates the `lesson_outline` field in the noteForm state.
 *
 * @param {string} e - The HTML string content from Quill editor.
 */
  const handleQuillChange = (e) => {
    setNewComment(e);
  };

  /**
 * Adds a reply to an existing comment.
 * @description Validates and posts a reply to a specific comment, then refreshes the comments list.
 */
  const handleReplyComment = async () => {
    setSendingMessage(true);
    try {
      let uploadedImages = {};
      if (selectedFile?.length > 0) {
        const formData = new FormData();
        // formData.append("file", selectedFile);
        selectedFile.forEach((file) => {
          formData.append("file", file);
        });

        const response = await httprequest.post(`${UPLOAD_ENDPOINT}`, formData);

        if (response?.status === 200 && response?.data?.data) {
          uploadedImages = response?.data?.data.map((file) => ({
            upload_id: file?.upload_id,
            file_url: file?.file_url
          }));
        }

        const replyId = replyToCommentId;
        if (!replyId || !replyComment) {
          toast.error("No comment or reply text provided.");

          return;
        }

        const payload = { reply: replyComment, comment_id: replyId, attachment: uploadedImages };
        await httprequest.patch(REPLY_ADMIN, payload);
        toast.success("Reply added successfully");
        setReplyComment("");
        setReplyToCommentId(null);
        fetchComments();
        setSelectedFile([]);
        setSendingMessage(false);
      } else {
        const replyId = replyToCommentId;
        if (!replyId || !replyComment) {
          toast.error("No comment or reply text provided.");

          return;
        }

        const payload = { reply: replyComment, comment_id: replyId };
        httprequest.patch(REPLY_ADMIN, payload)
          .then(() => {
            toast.success("Reply added successfully");
            setReplyComment("");
            setReplyToCommentId(null);
            fetchComments();
          });
      }
    } catch (err) {
      toast.error(err?.response?.data || "Failed to add reply");
    }
  };

  /**
 * Fetches ticket details by ID.
 * @description Retrieves and sets the details of the current ticket.
 */
  const getTicketById = () => {
    setIsLoading(true);
    httprequest(`${GET_TICKET_BY_ID}${id}`)
      .then((res) => {
        setIsLoading(false);
        setTicketDetails(res?.data?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Initiates a reply to a specific comment.
 * @param {string} commentId - The ID of the comment to reply to.
 * @description Sets up the UI state for replying to a comment.
 */
  const handleReplyClick = (commentId) => {
    setReplyToCommentId(commentId);
    setReplyComment("");
  };

  useEffect(() => {
    fetchComments();
    getTicketById();
  }, []);

  /**
 * Closes the current ticket.
 * @description Updates the ticket status to "closed" and refreshes the ticket data.
 */
  const handleCloseTicket = () => {
    setIsClosing(true);
    httprequest
      .patch(`${CLOSE_TICKET_BY_ID}${id}/close`, { ...closeticketForm, rating: ticketRating })
      .then(() => {
        toast.success("Ticket closed successfully");
        setIsClosing(false);
        getTicketById();
        fetchComments();
        handleCloseRateModal();
      })
      .catch((err) => {
        setIsClosing(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const handleRateATicket = () => {
    setIsClosing(true);
    httprequest
      .post(`${CLOSE_TICKET_BY_ID}${id}/rate`, { ...closeticketForm, rating: ticketRating })
      .then((res) => {
        toast.success(res?.data);
        setIsClosing(false);
        getTicketById();
        fetchComments();
        handleCloseRateModal();
        handleRateTicket();
      })
      .catch((err) => {
        setIsClosing(false);
        toast.error(err?.response?.data?.message);
      });
  };
  /**
 * an array of files
 * @param {*} e
 */
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const filesArray = Array.from(e.target.files);
      setSelectedFile(filesArray);
    }
  };

  const handleRemoveFile = (indexToRemove) => {
    const filtered = selectedFile.filter((_, i) => i !== indexToRemove);
    setSelectedFile(filtered);
  };

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/support/tickets"
                link_one_name="Tickets"
                active="View Ticket"
                description="View your ticket information here"
              />
            </div>
          </div>
          <div className="page-content">
            <div className={`${classes.previewsubheader} text-align-left`}>
              <div>
                <h3>{`#${ticketDetails?.ticket_id || "--/--"}  -  ${ticketDetails?.subject || "--/--"}`}</h3>
              </div>
            </div>
            {ticketDetails?.status === "closed" ? (
              <p className="ticket-closed">
               This ticket is closed. You may reply to this ticket to reopen it.
              </p>
            ) : null}
            <Grid container spacing={4} sx={{
              "@media (max-width:430px)": {
                flexDirection: "column-reverse"
              }
            }}
            >
              <Grid item lg={4} md={5} sm={12} xs={12}>
                <div className="left-container container-border">
                  <h4>Ticket Information</h4>
                  {isLoading ? (
                    <PageLoader />
                  ) : (
                    <div className={classes.details}>
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Ticket ID</p>
                              <h4>{ticketDetails?.ticket_id || "--/--"}</h4>
                            </div>
                          </div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Name</p>
                              <h4>{`${ticketDetails?.last_name || "--/--"} ${ticketDetails?.first_name || "--/--"}`}</h4>
                            </div>
                          </div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Email</p>
                              <h4>{ticketDetails?.email || "--/--"}</h4>
                            </div>
                          </div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Priority</p>
                              <h4><Badge status={ticketDetails?.priority} /></h4>
                            </div>
                          </div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Date Created</p>
                              <h4>{ticketDetails?.created_at?.substring(0, 10) || "--/--"}</h4>
                            </div>
                          </div>
                        </Grid>
                        {ticketDetails?.attachment?.file_url && (
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <div className={`${classes.previewsubheader} text-align-left`}>
                              <div className={classes.viewimg}>
                                <p>Attachment</p>
                                <h4 onClick={() => {
                                  setSelectedImageUrl(ticketDetails?.attachment?.file_url);
                                  setViewImages(true);
                                }}
                                >View Attachment
                                </h4>
                              </div>
                            </div>
                          </Grid>
                        )}
                        {ticketDetails?.rating === null && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div className={`${classes.previewsubheader} text-align-left`}>
                              <div>
                                <p>We hope your issue was resolved successfully.</p>
                                <div onClick={handleRateTicket} className="flex gap-5 cursor-pointer">
                                  <h4>Click to rate ticket</h4>
                                  <Icon icon="material-symbols:star-rate-half" />
                                </div>
                              </div>
                            </div>
                          </Grid>
                        )}
                      </Grid>
                    </div>
                  )}
                  {ticketDetails?.status === "open" && (
                    <Button
                      variant="primary"
                      buttonSize="full"
                      color="btndefault"
                      // isLoading={isClosing}
                      onClick={handleCommentModal}
                      buttonName="Close Ticket"
                    />
                  )}
                </div>
              </Grid>
              <Grid item lg={8} md={7} sm={12} xs={12}>
                <div className="support-right-container relative-full container-border">
                  <div className="support-section-top">
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <h5>{`#${ticketDetails?.ticket_id || "--/--"}  -  ${ticketDetails?.subject || "--/--"}`}</h5>
                      </div>
                    </div>
                    <div className={`${classes.subjectitems} text-align-left`}>
                      <div>
                        <h5>{`${ticketDetails?.message || "--/--"}`}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="all-support-chat-height">
                    {Array.isArray(comments) && comments?.length > 0 ? (
                      <div className="support_comment_div application_comment">
                        {comments?.map((item, index) => (
                          <div key={index} className={`admin_comment ${
                            item?.ref_type === "super_admin" && item?.user?.id === profile?.user_id
                              ? "user"
                              : item?.ref_type
                          }`}
                          >
                            {item?.image?.length > 0 &&
                            item?.image.map((img, index) => (
                              <img
                                key={img?.upload_id || index}
                                src={img?.file_url}
                                alt={`preview-${index}`}
                                className={classes.chatimage}
                                onClick={() => {
                                  setSelectedImageUrl(img?.file_url);
                                  setViewImages(true);
                                }}
                              />
                            ))}
                            {item?.type === "comment" ? (
                              <div className="comment_main">

                                <div className="apply comment_container">
                                  <p className=" no_margin">
                                    <strong>{item?.commenter?.last_name} {item?.commenter?.first_name}</strong>
                                  </p>
                                  <span className="admin_comment_span">
                                    {parse(item?.comment)}
                                    <div className={`comment_time ${item?.ref_type === "user" ? "justify_end" : "justify_start"}`}>{formatTime(item?.created_at)}</div>

                                  </span>
                                  {(item?.ref_type === "user" || item?.ref_type === "super_admin") && (
                                    <span
                                      className="reply"
                                      onClick={() => handleReplyClick(item.id)}
                                    >
                         Reply
                                    </span>

                                  )}
                                </div>
                              </div>
                            ) : (
                              <div className={`reply_container_${
                                item?.ref_type === "super_admin" && item?.user?.id === profile?.user_id
                                  ? "user"
                                  : item?.ref_type === "user" && item?.user?.id !== profile?.user_id
                                    ? "super_admin"
                                    : item?.ref_type
                              }`}
                              >
                                <div className="reply_main">
                                  <p className="reply-user  no_margin">
                                    <strong>{item?.commenter?.last_name}</strong>
                                  </p>
                                  <div className="original-comment">
                                    <div className="reply_com">
                                      <p className="original-comment-user no_margin">
                                        <strong>{comments.find(comment => comment?.id === item.parentCommentId)?.user?.last_name}</strong>
                                      </p>
                                      <span className="comment_span">
                                        {parse(comments.find(comment => comment?.id === item?.parentCommentId)?.comment)}
                                      </span>
                                    </div>
                                    <span className="reply_span">
                                      {parse(item?.reply)}
                                    </span>
                                    <div className={`comment_time ${
                                      item?.ref_type === "user" ||
  (item?.ref_type === "super_admin" && item?.user?.id === profile?.user_id)
                                        ? "justify_end"
                                        : "justify_start"
                                    }`}
                                    >{formatTime(item?.created_at)}
                                    </div>
                                  </div>

                                  {/* {(item?.ref_type === "user" || item?.ref_type === "super_admin") && (
                                    <span
                                      className="reply justify_end"
                                      onClick={() => {
                                        const parentComment = comments.find(comment => comment?.id === item?.parentCommentId);
                                        handleReplyClick(parentComment?.id);
                                      }}
                                    >
                                    Reply
                                    </span>
                                  )} */}

                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        {!displayChatbot && (
                          <div className="no_upload support_no_upload_centering">
                            <img src={nocomment} />
                            <h5>Want to follow up?</h5>
                            <p>Start the conversation by sending a message to our support team.</p>
                            <div className={classes.messageBtn}>
                              <Button
                                variant="primary"
                                buttonSize="medium"
                                color="btndefault"
                                buttonName="Send Message"
                                onClick={handleToggleMessage}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  {(displayChatbot || comments?.length > 0) && (
                    <div className={`${classes.fortextarea} margin-top-12 support-section-bottom`}>
                      {/* Default comment submission area, hidden when replying */}
                      {!replyToCommentId && (
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container spacing={2}>
                            {selectedFile?.length > 0 && (
                              <Grid item lg={6} md={12} sm={12} xs={12}>
                                <div className={classes.previewGrid}>
                                  {selectedFile.map((file, index) => {
                                    const fileUrl = URL.createObjectURL(file);

                                    return (
                                      <div key={index} className={classes.previewItem}>
                                        <img src={fileUrl} alt={`preview-${index}`} className={classes.previewImage} />
                                        <div
                                          className={classes.removeBtn}
                                          onClick={() => handleRemoveFile(index)}
                                        >
                                          <Icon icon="mdi:remove-bold" />
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </Grid>
                            )}
                          </Grid>

                          <div className={`${classes.quillposition}`}>
                            <ReactQuill
                              theme="snow"
                              onDrop={handleEditorDrop}
                              onChange={handleQuillChange}
                              onPaste={handlePaste}
                              formats={Quillformats}
                              modules={{
                                toolbar: [
                                  [{ "header": [1, 2, false] }],
                                  ["bold", "italic", "underline"],
                                  [{ "list": "ordered" }, { "list": "bullet" }],
                                  ["clean"]
                                ]
                              }}
                              value={newComment}
                              style={{
                                minHeight: "100px",
                                borderRadius: 20,
                                textAlign: "left",
                                border: "none",
                                "& qlContainer": { height: "100px" }
                              }}
                            />
                            <div className="flex gap-10 justifyRight margin-top-5 margin-right-bottom-8">
                              <div className={classes.addimages}>
                                <input
                                  type="file"
                                  multiple
                                  className={classes.pickimage}
                                  onChange={handleFileChange}
                                  style={{ border: "1px solid red" }}
                                  name="file"
                                  accept="image/jpeg,image/jpe,image/png"
                                />
                            Attach image <Icon icon="tdesign:attach" style={{ color: "#0065FF" }} />
                              </div>
                              <div className="send_comment flex" onClick={handleAddComment}>
                                {sendingMessage ? "Sending" : "Send"} <Icon icon="zondicons:send" />
                              </div>
                            </div>
                          </div>
                        </Grid>
                      )}
                      {/* Reply form, shown only when replying to a comment */}
                      {replyToCommentId && (
                        <div className="reply_div">
                          <Grid container spacing={2}>
                            {selectedFile?.length > 0 && (
                              <Grid item lg={6} md={12} sm={12} xs={12}>
                                <div className={classes.previewGrid}>
                                  {selectedFile.map((file, index) => {
                                    const fileUrl = URL.createObjectURL(file);

                                    return (
                                      <div key={index} className={classes.previewItem}>
                                        <img src={fileUrl} alt={`preview-${index}`} className={classes.previewImage} />
                                        <div
                                          className={classes.removeBtn}
                                          onClick={() => handleRemoveFile(index)}
                                        >
                                          <Icon icon="mdi:remove-bold" />
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </Grid>
                            )}
                          </Grid>
                          <div className="selected-comment-to-reply">
                            <div>
                              <span>
                                {comments.find(comment => comment.id === replyToCommentId)?.user?.last_name}
                              </span>
                              <p className="no_margin">
                                {parse(comments.find(comment => comment.id === replyToCommentId)?.comment)}
                                {comments.find(comment => comment.id === replyToCommentId)?.replies.reply}
                              </p>
                            </div>
                            <button className="cancel_reply" onClick={handleCancelReply}>
                              <Icon icon="ic:outline-cancel" />
                            </button>
                          </div>
                          <div className={`${classes.quillposition}`}>
                            <ReactQuill
                              theme="snow"
                              onDrop={handleEditorDrop}
                              onChange={(e) => setReplyComment(e)}
                              onPaste={handlePaste}
                              formats={Quillformats}
                              modules={{
                                toolbar: [
                                  [{ "header": [1, 2, false] }],
                                  ["bold", "italic", "underline"],
                                  [{ "list": "ordered" }, { "list": "bullet" }],
                                  ["clean"]
                                ]
                              }}
                              value={replyComment}
                              style={{
                                minHeight: "100px",
                                borderRadius: 20,
                                textAlign: "left",
                                "& qlContainer": { height: "100px" }
                              }}
                            />
                          </div>
                          <div className="flex gap-10 justifyRight margin-top-5 margin-right-bottom-8">
                            <div className={classes.addimages}>
                              <input
                                type="file"
                                multiple
                                className={classes.pickimage}
                                onChange={handleFileChange}
                                style={{ border: "1px solid red" }}
                                name="file"
                                accept="image/jpeg,image/jpe,image/png"
                              />
                            Attach image <Icon icon="tdesign:attach" style={{ color: "#0065FF" }} />
                            </div>
                            <div className="send_comment flex" onClick={handleReplyComment}>
                            Reply <Icon icon="zondicons:send" />
                            </div>
                          </div>
                          {/* <button className="upload_comment flex justify_end" onClick={handleReplyComment}>
                            Reply Message <Icon icon="zondicons:send" />
                        </button> */}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
          <Modal
            title=""
            subtitle={<div></div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="We'd love your feedback on this support."
                      margin="normal"
                      // required
                      placeHolder="Leave a comment"
                      inputType="text"
                      onChange={handleCloseTicketChange}
                      inputName="comment"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <div>
                      <div className={classes.starrating}>
                        {[1, 2, 3, 4, 5]?.map((star) => (
                          <span
                            key={star}
                            onClick={() => setTicketRating(star)}
                            onMouseOver={() => setHover(star)}
                            onMouseLeave={() => setHover(null)}
                          >
                            {star <= (hover || ticketRating) ? "★" : "☆"}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Close Ticket"
                    onClick={handleCloseTicket}
                    isLoading={isClosing}
                  />
                </div>
              </>
            }
            isopen={commentModal}
            closeModal={handleCloseRateModal}
          />
          {/* Rate and Comment Only */}
          <Modal
            title=""
            subtitle={<div></div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="We'd love your feedback on this support."
                      margin="normal"
                      // required
                      placeHolder="Leave a comment"
                      inputType="text"
                      onChange={handleCloseTicketChange}
                      inputName="comment"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <div>
                      <div className={classes.starrating}>
                        {[1, 2, 3, 4, 5]?.map((star) => (
                          <span
                            key={star}
                            onClick={() => setTicketRating(star)}
                            onMouseOver={() => setHover(star)}
                            onMouseLeave={() => setHover(null)}
                          >
                            {star <= (hover || ticketRating) ? "★" : "☆"}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Rate Ticket"
                    onClick={handleRateATicket}
                    isLoading={isClosing}
                  />
                </div>
              </>
            }
            isopen={rateticket}
            closeModal={handleRateTicket}
          />
          {/* Attachment Modal */}
          <Modal
            title="Attachments"
            subtitle={
              <div>View attachment
              </div>}
            modalContent={
              <>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <img
                      src={selectedImageUrl}
                      alt="Attachment Preview"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
              </>
            }
            isopen={viewImages}
            closeModal={handleViewImages}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default ViewTicket;
